import {
  EvidencePlugin,
} from './EvidencePlugin'

import type {
  GenesisExtensionManifest,
} from '../../platform/extensions/types'

export const manifest:
GenesisExtensionManifest = {
  id: 'evidence',
  name: 'Evidencias',

  description:
    'Resultados, pruebas, fingerprints, builds, deploy y rollback.',

  version: '1.0.0',
  apiVersion: '1',

  kind: 'MODULE',
  placement: 'RIGHT',

  priority: 30,

  enabledByDefault: false,
  removable: true,

  requiredCapabilities: [
    'evidence.read',
  ],

  component:
    EvidencePlugin,
}
